function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import React, { useId } from "react";
import { twMerge } from "@stereoagency/tailwind-config";
import { Button } from "../../atoms";
import { useAccentColors } from "../../hooks";
import { changeColorVariableWeight } from "../../utils";
import { FilterDropdown } from "../FilterDropdown";
var isOptionSelected = function(value, option) {
    return !!(value && value.includes(option.value));
};
export default function TagFilter(param) {
    var value = param.value, options = param.options, style = param.style, _param_accentColor = param.accentColor, accentColor = _param_accentColor === void 0 ? "--colors-red-700" : _param_accentColor, labelColor = param.labelColor, labelHoverColor = param.labelHoverColor, onChange = param.onChange, className = param.className;
    var id = useId();
    var hoverAccentColor = accentColor.startsWith("--colors-") ? changeColorVariableWeight(accentColor, function(v) {
        return v + 200;
    }) : accentColor;
    var accentStyle = useAccentColors([
        "colors-button-ghost-fg-hover",
        accentColor
    ], [
        "colors-button-main-bg-base",
        accentColor
    ], [
        "colors-button-main-bg-hover",
        hoverAccentColor
    ], [
        "colors-tag-label-color",
        labelColor
    ], [
        "colors-tag-label-hover-color",
        labelHoverColor || labelColor
    ]);
    var handleDropdownChange = function(val) {
        onChange === null || onChange === void 0 ? void 0 : onChange(val ? [
            val
        ] : []);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: className,
        style: _object_spread({}, style, accentStyle)
    }, /*#__PURE__*/ React.createElement("div", {
        className: "hidden flex-wrap justify-center items-center -my-2 md:flex"
    }, options.map(function(opt) {
        return /*#__PURE__*/ React.createElement(Button, {
            key: opt.value,
            id: "tagfilter-".concat(id, "-").concat(opt.value),
            role: "checkbox",
            "aria-checked": isOptionSelected(value, opt),
            "aria-labelledby": "tagfilter-".concat(id, "-").concat(value, "-label"),
            variant: isOptionSelected(value, opt) ? "primary" : "ghost",
            className: twMerge("font-bold my-2", isOptionSelected(value, opt) && "pointer-events-none"),
            onClick: function() {
                if (!onChange) return;
                onChange(opt.value ? [
                    opt.value
                ] : []);
            }
        }, /*#__PURE__*/ React.createElement("span", {
            className: "flex items-center text-[var(--colors-tag-label-color)] hover:text-[var(--colors-tag-label-hover-color)]"
        }, /*#__PURE__*/ React.createElement("span", {
            id: "tagfilter-".concat(id, "-").concat(value, "-label")
        }, opt.label), !!opt.suffix && /*#__PURE__*/ React.createElement("span", {
            className: "ml-3 font-normal text-navigation-small"
        }, opt.suffix)));
    })), /*#__PURE__*/ React.createElement("div", {
        className: "block md:hidden"
    }, /*#__PURE__*/ React.createElement(FilterDropdown, {
        accentColor: accentColor,
        value: (value === null || value === void 0 ? void 0 : value.length) ? value[0] : null,
        options: options,
        onChange: handleDropdownChange
    })));
}

//# sourceMappingURL=TagFilter.js.map